export default {
  data: function data() {
    return {};
  },
  props: {
    captchaConfig: {
      type: Object,
      default: function _default() {
        return {
          config: '',
          handler: ''
        };
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      window.initAlicom4(this.captchaConfig.config, this.captchaConfig.handler);
    }
  }
};